'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addClientTriggers = undefined;

var _scrollTriggerEnabled = require('../../scroll-percentage-trigger/operators/scrollTriggerEnabled');

var _postStartTrackScrollPercentage = require('../../scroll-percentage-trigger/actions/postStartTrackScrollPercentage');

var _timeOnPageTriggerEnabled = require('../../time-on-page-trigger/operators/timeOnPageTriggerEnabled');

var _addTimeOnPageTrigger = require('../../time-on-page-trigger/actions/addTimeOnPageTrigger');

var _exitIntentTriggerEnabled = require('../../exit-intent-trigger/operators/exitIntentTriggerEnabled');

var _postStartTrackExitIntent = require('../../exit-intent-trigger/actions/postStartTrackExitIntent');

var addClientTriggers = exports.addClientTriggers = function addClientTriggers(widgetData) {
  return function (dispatch) {
    if ((0, _scrollTriggerEnabled.scrollTriggerEnabled)(widgetData)) {
      dispatch((0, _postStartTrackScrollPercentage.postStartTrackScrollPercentage)());
    }

    if ((0, _timeOnPageTriggerEnabled.timeOnPageTriggerEnabled)(widgetData)) {
      dispatch((0, _addTimeOnPageTrigger.addTimeOnPageTrigger)(widgetData));
    }

    if ((0, _exitIntentTriggerEnabled.exitIntentTriggerEnabled)(widgetData)) {
      dispatch((0, _postStartTrackExitIntent.postStartTrackExitIntent)());
    }
  };
};